import { defineMessages } from 'react-intl'

const messages = defineMessages({
  heading: {
    id: 'invitation.accept.heading',
    description: 'Invitation accept page heading',
    defaultMessage: 'You\'ve been invited to {workspace}',
  },
  subheading: {
    id: 'invitation.accept.subheading',
    description: 'Invitation accept page sub-heading',
    defaultMessage: 'Accept your invitation for {email} to create your sign-in and join the workspace.',
  },
  acceptButton: {
    id: 'invitation.accept.acceptButton',
    description: 'Accept invitation button',
    defaultMessage: 'Accept & create sign-in',
  },
  acceptButtonSignedIn: {
    id: 'invitation.accept.acceptButtonSignedIn',
    description: 'Accept invitation button when already signed in',
    defaultMessage: 'Accept invitation',
  },
  invalidHeading: {
    id: 'invitation.accept.invalidHeading',
    description: 'Invalid/expired invitation heading',
    defaultMessage: 'This invitation link is no longer valid',
  },
  invalidBody: {
    id: 'invitation.accept.invalidBody',
    description: 'Invalid/expired invitation body',
    defaultMessage: 'It may have expired or already been used. Please ask your administrator to send a new invitation.',
  },
  errorHeading: {
    id: 'invitation.accept.errorHeading',
    description: 'Accept failed heading',
    defaultMessage: 'We couldn\'t complete your invitation',
  },
  errorBody: {
    id: 'invitation.accept.errorBody',
    description: 'Accept failed body',
    defaultMessage: 'Something went wrong accepting the invitation. Please try again, or ask for a new invitation.',
  },
  retry: {
    id: 'invitation.accept.retry',
    description: 'Retry accept button',
    defaultMessage: 'Try again',
  },
})

export default messages
